/**
 * 送り先の同一性判定用指紋。
 * 表記ゆれ（全角・〒・℡・空白など）を吸収して比較する。
 */

const HYPHEN_LIKE = '\u2010\u2011\u2012\u2013\u2014\u2015\u2043\u02d7\u2212\uff0d\u30fc\uff70';
const RE_DIGIT_HYPHEN = new RegExp(`([0-9])[${HYPHEN_LIKE}](?=[0-9])`, 'g');

function normalizeChar(ch) {
  const code = ch.charCodeAt(0);
  if (code >= 0xff10 && code <= 0xff19) return String.fromCharCode(code - 0xff10 + 0x30);
  if (code >= 0xff21 && code <= 0xff3a) return String.fromCharCode(code - 0xff21 + 0x41);
  if (code >= 0xff41 && code <= 0xff5a) return String.fromCharCode(code - 0xff41 + 0x61);
  if (code === 0xff1a) return ':';
  if (code === 0x3000) return ' ';
  return ch;
}

/** 比較用に文字列を正規化する（空は ''） */
export function normalizeDestinationPart(value) {
  if (value == null) return '';
  let out = '';
  const s = String(value).trim();
  for (let i = 0; i < s.length; i += 1) {
    out += normalizeChar(s[i]);
  }
  return out
    .replace(RE_DIGIT_HYPHEN, '$1-')
    // 〒 / ℡☎（直後のコロンも電話記号の一部として除去）
    .replace(/\u3012/g, '')
    .replace(/[\u2121\u260e]\s*:?/g, '')
    // リテラル TEL:（数字の直前のみ。hotel 等を壊さない）
    .replace(/tel\s*:?(?=\d)/gi, '')
    .replace(/\s+/g, '')
    .toLowerCase();
}

/**
 * 送り先が「空」か（名前・住所・電話がすべて空）。
 * 空どうしは同じ送り先とみなさない。
 */
export function isDestinationEmpty({ name, address, tel } = {}) {
  return (
    normalizeDestinationPart(name) === '' &&
    normalizeDestinationPart(address) === '' &&
    normalizeDestinationPart(tel) === ''
  );
}

/**
 * 送り先指紋。空の場合は null（グループ化禁止）。
 * @returns {string|null}
 */
export function destinationFingerprint({ name, address, tel } = {}) {
  if (isDestinationEmpty({ name, address, tel })) return null;
  return [
    normalizeDestinationPart(name),
    normalizeDestinationPart(address),
    normalizeDestinationPart(tel),
  ].join('|');
}

/** 行オブジェクトから送り先指紋を取る */
export function fingerprintFromShareRow(row) {
  if (!row) return null;
  return destinationFingerprint({
    name: row.juchu_direct_name,
    address: row.juchu_direct_address,
    tel: row.juchu_direct_tel,
  });
}
